import styled from 'styled-components';
import { asRem } from 'utils/asRem';
import { mediaQueries } from 'utils/Constants/Breakpoints';

export default styled.main`
  padding: ${asRem(70)} 0 0 0;

  ${mediaQueries.md} {
    padding: ${asRem(30)} 0 0 0;
  }

  .zpp-offer-wrapper {
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    align-items: center;

    ${mediaQueries.md} {
      flex-direction: row;
      justify-content: space-between !important;
      align-items: flex-start;
    }
  }

  .offer-wrapper {
    display: flex;
    flex-direction: column;
    justify-content: flex-end;
    align-items: center;

    ${mediaQueries.md} {
      flex-direction: column;
      justify-content: space-between !important;
      align-items: flex-end;
    }
  }
`;
